import { trash } from './trash';

export default trash;
